// Initialize BASE URL
if(false){
  var BASE_URL = "https://dash.level-sense.com/Level-Sense-API/web/app_dev.php";
}else{
  var BASE_URL = "https://dash.level-sense.com/Level-Sense-API/web";
}

$(document).ready(function(){
  window.localStorage.setItem('user-token', '');
  if($('form#customer_login .btn-login').length > 0) {
    $('form#customer_login .btn-login').click(_login);
  }
  
  
  if($('form#recover_customer_password button.form__submit').length > 0) {
    $('form#recover_customer_password button.form__submit').click(function() {
    	$(this).attr('disabled', true);
		$(this).find('.spinner-border').show();
      	
      	$('form#recover_customer_password').submit();
      	return true;
    });
  }
  
  if($('form#recover_customer_password .btn-reset-password-submit').length > 0) {
    $('form#recover_customer_password .btn-reset-password-submit').click(_otp);
  }
  
  if($('form#create_customer .btn-register').length > 0) {
    $('form#create_customer .btn-register').click(_register);
  }
  
});

function _login(e) {
  e.preventDefault();
  
  $('#customer_login .btn-login').attr('disabled', true);
  $('#customer_login .btn-login .spinner-border').show();
  
  var params = {};
  params.email = $("#customer_email").val();
  params.password = $("#customer_password").val();
  
  $.ajax({
  	url: BASE_URL+"/api/v1/login",
    type: 'POST',
    data: JSON.stringify(params),
    dataType: 'json',
    crossDomain:true,
    async:true,
    contentType: 'application/json; charset=utf-8',
	success: function (result) {
      if(result.success && result.isFirstLogin) {
        sweetAlert("Please, reset your password!");
        showRecoverPasswordForm();
              
        $('#customer_login .btn-login').removeAttr('disabled');
        $('#customer_login .btn-login .spinner-border').hide();
              
        return false;
      } else if(result.success) {
          if(result.errorId1 == "117") {
            sweetAlert("We have sent an account activation mail to your registered email-id, Please activate Your account first.");
          } else{
              window.localStorage.setItem('user-token', result.sessionKey);
              $("#customer_login").submit();
          }
      } else if(result.success == false) {
		if(result.errorId1 == "116") {
			sweetAlert(result.message);
		} else if(result.errorId1 == "117") {
			sweetAlert("We have sent an account activation mail to your registered email-id, Please activate Your account first.");
		} else if(result.errorId1 == "118") {
			sweetAlert("Something went wrong, please try again.");
		} else{
          sweetAlert(result.message);
        }
        
        $('#customer_login .btn-login').removeAttr('disabled');
        $('#customer_login .btn-login .spinner-border').hide();
      }
	}, error: function (error) {
      $('#customer_login .btn-login').removeAttr('disabled');
      $('#customer_login .btn-login .spinner-border').hide();
      
      err_html = "<div class='note form-error'><p>Sorry, looks like something went wrong. Please correct the following and submit again:</p><ul class='disc'><li>Invalid login credentials.</li></ul></div>";
	  $("#login-form-error").html(err_html);
	}
  });
}

function _otp(e) {
  e.preventDefault();
  
  var params = {};
  params.email = $("#recover_customer_email").val();
  
  $.ajax({
      url: BASE_URL+"/api/v2/otp",
      type: 'POST',
      data: JSON.stringify(params),
      dataType: 'json',
      crossDomain:true,
      async:true,
      contentType: 'application/json; charset=utf-8',
      success: function (result) {
        if(result.success){
          sweetAlert("One Time Password Sent Successfully!  Please check your email.");
          window.localStorage.setItem('user-token', result.sessionKey);
		  _showResetPasswordForm();
          $('form#reset_customer_password p.alert--success').text("We've sent you email. Use One Time Password to access your account.").show();
          $('form#reset_customer_password p.intruction-message').text('Enter a new password for '+params['email']).show();
        } else if(result.success == false){
          sweetAlert("E-Mail Address Not Registered !");
        } else{
          sweetAlert("Please resend the One Time Password and forget password url!");
          _showResetPasswordForm();
          return false;
        }
      },
      error: function (error) {
        sweetAlert("Please resend the One Time Password!");
        _resetPassword();return false;
       /* err_html = "Sorry, looks like something went wrong. Please resend the One Time Password:<ul class='disc'><li>Invalid login credentials.</li></ul>";
        $(".form_errors").html(err_html);*/
      }
    });
}

function _showResetPasswordForm() {
  $('form#recover_customer_password').hide();
  $('form#reset_customer_password p.alert--success').hide();
  $('form#reset_customer_password p.intruction-message').hide();
  $('form#reset_customer_password').show();
}


function _resetPassword() {
  $('form#recover_customer_password').show();
  $('form#reset_customer_password').hide();
}

function _register() {
  $('#create_customer .btn-register').attr('disabled', true);
  $('#create_customer .btn-register .spinner-border').show();
  
  var params = {};
  params.firstName 	= $('#create_customer input[name="customer[first_name]"]').val();
  params.lastName 	= $('#create_customer input[name="customer[last_name]"]').val();
  params.email 		= $.trim($('#create_customer input[name="customer[email]"]').val());
  params.password 	= $.trim($('#create_customer input[name="customer[password]"]').val());
  
  if($('#create_customer').valid()){
  	$.ajax({
        url: BASE_URL+"/api/v1/registerUser",
       	type: 'POST',
       	data: JSON.stringify(params),
       	dataType: 'json',
       	crossDomain:true,
       	async:true,
       	contentType: 'application/json; charset=utf-8',
       	success: function (result){
          if(result.success){
            if(result.errorId1 == "116"){
              swal({
                  title:'Warning',
                  text:"You are already registered with us, please LogIn",
                  type:'warning'
                });
              
              _enableRegisterButton();
            } else if(result.errorId1 == "117") {
              sweetAlert("We have sent an account activation mail to your registered email-id, Please activate Your account first.");
              _enableRegisterButton();
            } else if(result.errorId1 == "118") {
              sweetAlert("Something went wrong, please try again.");
              _enableRegisterButton();
            } else if(result.migrated == 1){
              window.localStorage.setItem('user-token', result.sessionKey);
              window.localStorage.setItem('migrated',true);
              
              jQuery("#create_customer").submit();
            } else if(result.migrated == 0){
              window.localStorage.setItem('user-token', result.sessionKey);
              
              jQuery("#create_customer").submit();
            } else{
              	console.log(result);
            	window.localStorage.setItem('user-token', result.sessionKey);
              	
              let form = document.getElementById("create_customer");
              form.submit();
              //jQuery("#create_customer").submit();
            }
          } else if(result.success == false) {
            if(result.errorId1 == "116"){
              swal({
                title:'Warning',
                text:"You are already registered with us, please LogIn",
                type:'warning'
              });
              _enableRegisterButton();
            } else if(result.errorId1 == "117") {
              sweetAlert("We have sent an account activation mail to your registered email-id, Please activate Your account first.");
              _enableRegisterButton();
            } else if(result.errorId1 == "118") {
              sweetAlert("Something went wrong, please try again.");
              _enableRegisterButton();
            } else if(result.errorId == '106'){
              swal(
                {
                  title:'Warning',
                  text:"You are already registered with us, please LogIn again for better user experience.",
                  type:'warning'
                }
              );
              _enableRegisterButton();
            } else if(result.errorId == '114'){
              swal(
                {
                  title:'Congratulations!!!',
                  text:"Your account has been successfully migrated.",
                  type:'success',
                  timer: 2000,
                  showConfirmButton: false
                },function(value){
                  window.localStorage.setItem('user-token', result.sessionKey);
                  $("#create_customer").submit();
                }
              );
            } else if(result.errorId == '113'){
              $("#create_customer").submit();
              var span = "You have been successfully migrated. Please Reset your password first to login.";
              swal(
                {
                  html: true,
                  title:'Migrated!! need to reset password',
                  text:span,
                  type:'info'
                }
              );
            } else{
              sweetAlert(result.message);
              _enableRegisterButton();
            }
          }
        },
        error: function (error) {
          _enableRegisterButton();
          
          err_html = "<div class='alert alert--error'><p>Sorry, looks like something went wrong. Please correct the following and submit again:</p><ul class='disc'><li>User with given email already exists.</li></ul></div>";
          $("#create_customer .form_errors").html(err_html);
        }
      });
  } else {
    $('#create_customer .btn-register').removeAttr('disabled');
  	$('#create_customer .btn-register .spinner-border').hide();
  }
}

function _enableRegisterButton() {
	$('#create_customer .btn-register').removeAttr('disabled');
    $('#create_customer .btn-register .spinner-border').hide();
}